// removed by extract-text-webpack-plugin
module.exports = {"base":"src-components-ProjectListing----ProjectListing-module---base---1Mw9Z","wrapper":"src-components-ProjectListing----ProjectListing-module---wrapper---2iw-5","gatsby-image-wrapper":"src-components-ProjectListing----ProjectListing-module---gatsby-image-wrapper---38KTo","content":"src-components-ProjectListing----ProjectListing-module---content---1J9Nr","image":"src-components-ProjectListing----ProjectListing-module---image---1zs0X","overlay":"src-components-ProjectListing----ProjectListing-module---overlay---2HwJb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectListing/ProjectListing.module.scss
// module id = 506
// module chunks = 19843951674672